import { BrowserModule } from '@angular/platform-browser';
import { NgModule,LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExtendedHttpService } from './jwt-interceptor';
import { Http, HttpModule } from '@angular/http';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './auth.guard';
import { LoginServico } from './servicos/login.servico';
import { UtilServico } from './servicos/util.servico';
import { AppComponent } from './app.component';
import { AdmComponent } from './login/adm.component';
import { HomeComponent } from './home/home.component';
import { InicialComponent } from './inicial/inicial.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { LayoutInicialComponent } from './layout/layout-inicial/layout-inicial.component';
import { MatButtonModule, MatCheckboxModule, MatSelectModule, MatInputModule, MatMenuModule,MatIconModule, MatListModule, MatDatepickerModule, MatNativeDateModule, MatTabsModule } from '@angular/material';
import { CoolDirective } from './cool.directive';
import { NgxPaginationModule } from 'ngx-pagination';
import {NgxMaskModule} from 'ngx-mask';
import { CurrencyMaskModule } from "ngx-currency-mask";
import { NgBootstrapFormValidationModule } from 'ng-bootstrap-form-validation';
import localePt from '@angular/common/locales/pt';
import { MatTab } from '@angular/material/tabs/typings/tab';
import { UtilDadosLogado } from './servicos/util.logado';
import {MatRadioModule} from '@angular/material/radio';
registerLocaleData(localePt, 'pt-BR');

const MY_DATE_FORMATS = {
  parse: {
      dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
      dateInput: 'input',
      monthYearLabel: { year: 'numeric', month: 'numeric' },
      dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
      monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
}; 
@NgModule({
  exports: [MatButtonModule, MatCheckboxModule, MatSelectModule, MatInputModule, MatMenuModule, MatIconModule, MatListModule, MatDatepickerModule, MatNativeDateModule,MatTabsModule,MatRadioModule],
  
})
export class MaterialModule { }

@NgModule({
  declarations: [
    AppComponent,
    AdmComponent,
    HomeComponent,
    InicialComponent,
    LayoutInicialComponent,      
    CoolDirective       
  ],
  imports: [
    HttpModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgxPaginationModule,
    NgxMaskModule.forRoot(),
    CurrencyMaskModule,
    NgBootstrapFormValidationModule.forRoot()
   
  ],
  providers: [AuthGuard, LoginServico, UtilServico,UtilDadosLogado,{ provide: LOCALE_ID, useValue: 'pt-BR' },
  {
    provide: Http,
    useClass: ExtendedHttpService
  },],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Agents/es/_work/11/s/ANGULAR/src/app/app.module.ts